import { ProjectTaskType } from '@/entities/project';

import { Project } from '@/shared/types/Project';

import { TASK_CONSTANTS } from '../constants/taskTypeConstants';
// Вычисляет текущий процент на основании текущего статуса
const getCurrentPercentForStatus = ({
  finalPercent,
  startPercent,
  statusStartDate,
  taskGeneratingSec,
  videoDuration,
}: {
  // Финальный процент для текущего процесса
  finalPercent: number;
  // Начальный процент для текущего процесса
  startPercent: number;
  statusStartDate: Project['status_date'];
  // Время, которое занимает текущий процесс для 60сек видео
  taskGeneratingSec: number;
  videoDuration: Project['duration'];
}) => {
  if (!videoDuration) {
    return startPercent;
  }
  try {
    // Сколько времени должен выполняться текущий процесс
    const currentStatusTotalExecutionTimeMs = Math.ceil(((taskGeneratingSec * videoDuration) / 60) * 1000);
    // Сколько времени он уже выполняется
    const currentStatusAlreadyExecutedTimeMs = Math.floor(Date.now() - new Date(statusStartDate).getTime());
    // Процент, который занимает текущий процесс от всего процесса загрузки или генерации видео
    const currentTaskPercent = finalPercent - startPercent;
    // Вычисляем процент через пропорцию
    // [Сколько времени должен выполняться текущий процесс] сек = [Процент для текущего процесса от целого процесса] %
    // 10 сек = 10%
    // 2 сек = x%
    // x = (2 * 10) / 10 = 2%
    const percentOfCurrentTask = Math.floor(
      (currentStatusAlreadyExecutedTimeMs * currentTaskPercent) / currentStatusTotalExecutionTimeMs,
    );
    // Если в текущем процессе должен показываться бОльший % чем endPercent, то показываем endPercent
    // Если всё ок, то прибавляем вычисленный процент к минимальному проценту текущего процесса
    // Math.max против startPercent защищает от рассинхрона часов клиент/сервер: если statusStartDate
    // приходит «из будущего», percentOfCurrentTask становится отрицательным и без clamp давал бы
    // отрицательный итог (визуально ломал верстку в ProjectProcessing/styled.tsx).
    return percentOfCurrentTask > currentTaskPercent
      ? finalPercent
      : Math.max(startPercent, startPercent + percentOfCurrentTask);
  } catch (e) {
    console.error(e);
    return startPercent;
  }
};
export const getInitialPercent = (
  status: Project['status'],
  statusStartDate: Project['status_date'],
  videoDuration: Project['duration'],
  taskType: Exclude<ProjectTaskType, 'voiceUpdate'>,
) => {
  const { finalPercentForStatus, initialPercentForStatus, taskDurationSec } = TASK_CONSTANTS[taskType];
  const canGetPercentForStatus = Boolean(
    taskDurationSec[status] && initialPercentForStatus[status] && finalPercentForStatus[status],
  );
  return canGetPercentForStatus
    ? getCurrentPercentForStatus({
        finalPercent: finalPercentForStatus[status] as number,
        startPercent: initialPercentForStatus[status] as number,
        statusStartDate,
        taskGeneratingSec: taskDurationSec[status] as number,
        videoDuration,
      })
    : 0;
};
